import { Helmet } from 'react-helmet-async'
import { Link } from 'react-router-dom'
import { Key, ArrowLeft, Clock } from 'lucide-react'

export function Waitlist() {
  return (
    <>
      <Helmet>
        <title>Beta Access | Twenty</title>
        <meta name="description" content="Join the Twenty beta. Simplify the last 20% of infrastructure so you can actually ship." />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      
      <div className="min-h-screen bg-background">
        <nav className="border-b border-border">
          <div className="max-w-4xl mx-auto px-6 h-16 flex items-center justify-between">
            <Link to="/" className="flex items-center gap-2">
              <Key className="w-5 h-5 text-primary" />
              <span className="font-semibold">Twenty</span>
            </Link>
            <Link to="/" className="text-sm text-muted-foreground hover:text-foreground flex items-center gap-1">
              <ArrowLeft className="w-4 h-4" />
              Back
            </Link>
          </div>
        </nav>

        <main className="max-w-xl mx-auto px-6 py-20 text-center">
          <div className="w-16 h-16 bg-secondary rounded-full flex items-center justify-center mx-auto mb-6">
            <Clock className="w-8 h-8 text-muted-foreground" />
          </div>
          
          <h1 className="text-3xl font-semibold mb-4">You're in line</h1>
          
          <p className="text-muted-foreground mb-8">
            Sorry, Twenty is currently in private beta. We're letting in new users 
            gradually to ensure a great experience.
          </p>

          <div className="card-factory p-6 mb-8 text-left">
            <h2 className="font-medium mb-4">What to expect:</h2>
            <ul className="space-y-3 text-sm text-muted-foreground">
              <li className="flex items-start gap-2">
                <span className="text-primary">•</span>
                Beta access is invite-only right now
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary">•</span>
                Request access from the homepage
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary">•</span>
                We'll email you when it's your turn
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary">•</span>
                Priority given to active builders
              </li>
            </ul>
          </div>

          <Link to="/" className="btn-factory">
            Request beta access
          </Link>

          <p className="mt-8 text-sm text-muted-foreground">
            Have an invite code? Contact support@twenty.sh
          </p>
        </main>

        <footer className="border-t border-border py-8 mt-auto">
          <div className="max-w-4xl mx-auto px-6 text-center">
            <p className="text-sm text-muted-foreground">
              © {new Date().getFullYear()} Twenty
            </p>
          </div>
        </footer>
      </div>
    </>
  )
}
